export const styles = {
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
    textAlign: "left",
  },
  subSection: {
    marginLeft: 25,
    paddingLeft: 5,
    flexGrow: 1,
    textAlign: "left",
  },
  text: {
    margin: 4,
    fontSize: 12,
    textAlign: "left",
    fontFamily: "Roboto",
  },
  headerText: {
    margin: 4,
    fontSize: 18,
    textAlign: "left",
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  pageHeaderText: {
    margin: 4,
    fontSize: 20,
    textAlign: "center",
    fontFamily: "Roboto",
    fontWeight: "bold",
    textDecoration: "underline",
  },
  subHeaderText: {
    margin: 4,
    fontSize: 14,
    textAlign: "left",
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  image: {
    marginLeft: "85%",
    width: "15%",
    height: "auto",
    zindex: 100,
  },
  page: {
    padding: 40,
  },
};
